/**
 * Module dependencies.
 */

import styled from '@emotion/styled';

/**
 * Export `MenuWrapper` styled component.
 */

export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding-top: 10px;
`;
